export const featuresConstants = {
    FEATURES_REQUEST: 'FEATURES_REQUEST',
    FEATURES_SUCCESS: 'FEATURES_SUCCESS',
    FEATURES_FAILURE: 'FEATURES_FAILURE'
};